import React, { ReactElement } from 'react'
import StepFileUpload from './StepFileUpload'
import useUploadHook from '../../hooks/UseUploadHook'
import { IStepUploadWithValidateButtonProps } from '../../interfaces/Upload'

function StepUploadWithValidateButton(
  props: IStepUploadWithValidateButtonProps
): ReactElement {
  const { state, setState, validateFile, index } = props
  const { uploadFile } = useUploadHook({
    index,
    setState,
    mainState: state,
    validateFile,
  })

  const { toggleValidateButton, validationButtonError } = state[index]

  return (
    <div>
      <StepFileUpload
        {...{ ...props }}
        loadingSpinnerClassName="dFlex justifyContentEnd"
      />
      {toggleValidateButton && (
        <div className="textRight">
          <button
            className="btn btnPrimary btnPrimaryMd wFull wAutoSm"
            type="button"
            onClick={uploadFile}
          >
            Valider les documents
          </button>
          {validationButtonError && (
            <p className={`${validationButtonError.type}Error mt1`}>
              {validationButtonError?.message}
            </p>
          )}
        </div>
      )}
    </div>
  )
}

export default StepUploadWithValidateButton
